module.exports = __webpack_public_path__ + "static/administracion-8b8eb619a4b929d42a55cec2cb80f0ee.png";